import { flattenQueryStringValuePossiblyNull } from "@lib/utils";
import { NextRouter } from "next/router";
import { getConnectionFromQueryStringOrFragment } from "../auth0/auth0";

// login2 - {"name":"auth0-react","version":"2.2.1"}
// breakit app - `{"name":"Auth0.swift","version":"2.5.0","env":{"iOS":"17.1","swift":"5.x"}}
type Auth0Client = {
  name: string;
  version: string;
};

const APP_CLIENT_IDS = ["Auth0.swift"];

export type sendParam = "link" | "code";

export function getSendParamFromAuth0ClientHeader(
  router: NextRouter,
): sendParam {
  if (getConnectionFromQueryStringOrFragment() === "auth0") {
    return "code";
  }

  const auth0ClientParam = flattenQueryStringValuePossiblyNull(
    router.query.auth0Client,
  );

  if (!auth0ClientParam) return "link";

  const decodedAuth0Client = atob(auth0ClientParam); // can we use Zod?

  const auth0Client = JSON.parse(decodedAuth0Client) as Auth0Client;

  console.log(auth0Client);

  const isAppClient = APP_CLIENT_IDS.includes(auth0Client.name);

  return isAppClient ? "code" : "link";
}
